import Vue from 'vue'
import {
  AppHeader,
  AppSidebar,
  PageDrawer,
  ColumnView,
  FilterDialog
} from '@/components'

// 全局注册组件
Vue.component('AppHeader', AppHeader)
Vue.component('AppSidebar', AppSidebar)
Vue.component('PageDrawer', PageDrawer)
Vue.component('ColumnView', ColumnView)
Vue.component('FilterDialog', FilterDialog)
